
import "../Styles/Account.css"
import Navbar from "../components/Navbar"

const Account = () => {

    return<>
        <Navbar/>

    </>

}

export default Account